import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();

  // useEffect(() => {
  //   oktaAuth.signInWithRedirect();
  // }, [oktaAuth])
  // Redirect to Okta for authentication if not authenticated
  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, authState]);

  if (!authState) {
    return <div>Loading ... </div>;
  }

  // return authState.isAuthenticated ?
  //   <Redirect to={{ pathname: '/tableau' }} />
  //   : null;
  if (authState.isAuthenticated) {
    return <Redirect to="/tableau" />;
  }

  // Sinon, on affiche rien (car redirection Okta est en cours)
  return null;
};

export default Login;
